import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Zeta from "../images/david-holifield-4SLhp1olvFc-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice ZETA 140 S" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 140
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              ZETA 140 S
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid ZETA 140 S je vzhľadom na svoju extrémnu superskorosť
              vhodný pre pestovanie na kukurice siláž do chladnejších podmienok
              horskej výrobnej oblasti. S možnosťou sejby v polovici mája po
              období neskorých jarných mrazíkov a zberom na siláž začiatkom
              septembra pred príchodom prvých jesenných mrazíkov. Vzhľadom na
              nižší habitus a relatívne vyšší pomer šúľkov k celej rastline
              odporúčame jeho vyššie zahustenie na 120 000 rastlín na ha a v
              prípade dobre živinami a vodou zásobených pôd aj na 130 000
              rastlín na ha. V prípade uplatnenia na zrno, CCM a LKS, však treba
              prispôsobiť organizáciu porastu na 100 000 rastlín na ha. V
              teplejších a humídnych oblastiach možno odporučiť vzhľadom na
              extrémnu superskorosť aj možnosť využitia pre pestovanie kukurice
              ako medziplodiny.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Dc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">medzityp</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Pre pestovanie na siláž</span>
              <span className="ml-auto text-gray-900">
                120 000 <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pre pestovanie na zrno, CCM a LKS
              </span>
              <span className="ml-auto text-gray-900">
                100 000 <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Extrémna skorosť pre pestovanie kukurice na siláž v horskej
                    oblasti{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Relatívne vyšší podiel šúľkov
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Adaptabilita k vyššiemu zahusteniu porastu
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Rýchly nárast sušiny šúľkov pred príchodom skorých jesenných
                    mrazíkov
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Možnosť využitia ako medziplodiny v teplejších a humídnych
                    podmienkach
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice ZETA 140 S"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Zeta}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2008 - 2009
        (priemer lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Hybrid
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchých šúľkov (t/ha)
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Sušina zrna (%)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> </td>
            <td className="bg-gray-200 px-4 py-3 ">
              priemer rokov 2008 - 2009
            </td>
            <td className="px-4 py-3 bg-gray-200">priemer rokov 2008 - 2009</td>
          </tr>
          <tr>
            <td className="border-t-2 border-gray-300 bg-gray-300 px-4 py-3 rounded-bl rounded-tl">
              ZETA 140 S
            </td>
            <td className="border-t-2 border-gray-100 bg-gray-100 px-4 py-3">
              9,11
            </td>
            <td className="border-t-2 border-gray-100 bg-gray-100 px-4 py-3">
              50,10
            </td>
          </tr>
          <tr>
            <td className="border-t-2 border-gray-300 bg-gray-200 px-4 py-3 rounded-bl rounded-tl">
              EDUARDO
            </td>
            <td className="border-t-2 bg-gray-200 px-4 py-3">8,90</td>
            <td className="border-t-2 border-gray-300 bg-gray-200 px-4 py-3">
              47,20
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2009 z Bodorovej:
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Hybrid
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchých šúľkov (t/ha)
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Sušina zrna (%)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 ">ZETA 140 S</td>
            <td className="bg-gray-100 px-4 py-3 border-t-2">8,54</td>
            <td className="bg-gray-100 px-4 py-3">42,80</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">EDUARDO</td>
            <td className="bg-gray-300 px-4 py-3 border-t-2">4,50</td>
            <td className="px-4 py-3 bg-gray-300">39,50</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
